import { useState, useEffect } from "react";

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

const useCopyToClipboard = () => {
    const [copiedText, setCopiedText] = useState<CopiedValue>(null);

    const copy: CopyFn = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Failed to copy:", error);
            setCopiedText(null);
            return false;
        }
    };

    useEffect(() => {
        if (copiedText) {
            const timer = setTimeout(() => {
                setCopiedText(null);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [copiedText]);

    return {
        copiedText,
        copy,
    };
};

export default useCopyToClipboard;
